// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.filter .mobile-window__footer {
    justify-content: center;
    background-color: var(--color-light-periwinkle-crayola);
    gap: 15px;
}

.filter .mobile-window__footer .button {

}

.filter .mobile-window__footer .button.button__cancel {
    background-color: var(--color-gray-window) !important;
}

@media screen and (max-width: 1024px) {
    .filter .filter__clear {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/catalog/main.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,uDAAuD;IACvD,SAAS;AACb;;AAEA;;AAEA;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["\n.filter .mobile-window__footer {\n    justify-content: center;\n    background-color: var(--color-light-periwinkle-crayola);\n    gap: 15px;\n}\n\n.filter .mobile-window__footer .button {\n\n}\n\n.filter .mobile-window__footer .button.button__cancel {\n    background-color: var(--color-gray-window) !important;\n}\n\n@media screen and (max-width: 1024px) {\n    .filter .filter__clear {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
